import React from "react";
import QRCode from "react-qr-code";
import eventPoster from "../../Assets/Eventposter.png";
import Ticket from "../../Assets/Ticketavailableicon.svg";
import { convertTo12HourFormat } from "../../utils/time_formatter";

const BookingCard = ({ booking, eventData }) => {
  // Format date as "10 May 2024"
  const formatDate = (dateString) => {
    if (!dateString) return "Date";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "Date";
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "UTC",
    });
  };

  const formatTimeRange = (startTime, endTime) => {
    if (!startTime) return "";
    const startFormatted = convertTo12HourFormat(startTime);
    if (endTime) {
      return `${startFormatted} - ${convertTo12HourFormat(endTime)}`;
    }
    return startFormatted;
  };

  return (
    <div className="flex flex-col md:flex-row bg-[#202020] rounded-xl overflow-hidden shadow-lg border border-[#333]">

      {/* 1. Poster Image (Left) */}
      <div className="w-full md:w-[200px] h-[250px] md:h-auto flex-shrink-0 relative">
        <img
          src={eventData?.poster?.verticalUrl || eventData?.poster?.horizontalUrl || eventData?.posterUrl || eventData?.imageUrl || eventPoster}
          alt="Event Poster"
          className="w-full h-full object-cover"
        />
        {/* Category Tag Overlay */}
        <div className="absolute top-3 right-3 bg-[#17BD3B] text-white text-[10px] font-bold px-2 py-1 rounded">
          {eventData?.category || "Music Festival"}
        </div>
      </div>

      {/* 2. Details Section (Middle) */}
      <div className="flex-1 p-6 flex flex-col justify-between">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-white mb-2 leading-tight">
            {eventData?.name || eventData?.title || "Event Name"}
          </h2>

          <p className="text-gray-400 text-sm mb-4">
            {eventData?.eventLocation?.locationText || eventData?.location || eventData?.eventLocationText || "Location"}
            <br />
            <span className="text-white font-medium">
              {formatDate(eventData?.date || booking.ticketDate)} | {formatTimeRange(eventData?.startTime || booking.ticketSlot, eventData?.endTime)}
            </span>
          </p>

          <div className="flex items-center gap-2 text-gray-300 text-sm mb-6">
            <img src={Ticket} alt="Ticket" className="w-5 h-5 opacity-70" />
            <span>{booking.ticketName || booking.ticketType?.name || "Regular Ticket"} x {booking.ticketCount || 1} | Early Bird</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap gap-3">
          <button className="px-4 py-2 rounded border border-[#333] text-[#17BD3B] text-sm font-medium hover:bg-[#17BD3B]/10 transition-colors">
            Download Invoice
          </button>

          <button className="px-4 py-2 rounded bg-[#17BD3B] hover:bg-[#15a834] text-white text-sm font-medium flex items-center gap-2 transition-colors shadow-lg shadow-[#17BD3B]/20">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg>
            Download Ticket
          </button>
        </div>

        {/* Booking ID (Mobile only, desktop is below QR) */}
        <div className="mt-4 text-xs text-gray-500 md:hidden">
          Booking Id : <span className="text-gray-300">{booking.id}</span>
        </div>
      </div>

      {/* 3. QR Code Section (Right) */}
      <div className="p-6 flex flex-col items-center justify-center border-t md:border-t-0 md:border-l border-[#333] bg-[#252525] md:bg-transparent min-w-[180px]">
        <div className="bg-white p-2 rounded-lg mb-4">
          <QRCode
            value={booking.id}
            size={100}
            className="w-[100px] h-[100px]"
          />
        </div>
        <div className="text-xs text-gray-500 hidden md:block text-center">
          Booking Id : <br />
          <span className="text-gray-300 font-mono">{booking.id}</span>
        </div>
      </div>

    </div>
  );
};

export default BookingCard;